import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class CrispR1MerchantNameFilter extends Component {
    state = {
        merchantNameList: [],
        merchantNameValue: [],
        isMerchantNameLoading: true
    };

    componentDidMount() {
        this._getMerchantNames();
    }

    resetCrispR1MerchantNameFilter() {
        this.setState({
            merchantNameValue: [],
        });
    }

    _getMerchantNames() {
        axios.get(config.get('API_URL') + '/filters/get-crisp-r1-merchant-names/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if (Array.isArray(response.data) && response.data.length) {
                const merchantNameList = response.data.map((item) => ({
                    value: item.merchant_name,
                    label: item.merchant_name
                }));
                this.setState({
                    merchantNameList,
                    isMerchantNameLoading: false
                });
            }
        }).catch(err => {
            console.error("Error fetching merchant names:", err);
            this.setState({ isMerchantNameLoading: false });
        });
    }

    changeCrispR1MerchantName(optionSelected) {
        let merchantArray = [];
        if (optionSelected && optionSelected.length > 0) {
            optionSelected.forEach((item) => {
                merchantArray.push(item.value);
                const index = this.state.merchantNameList.findIndex(obj => obj.value === item.value);
                this.state.merchantNameList.splice(index, 1);
                this.state.merchantNameList.unshift(item);
            });
        }

        this.props.onSelectCrispR1MerchantName(optionSelected, merchantArray);

        this.setState({
            merchantNameValue: optionSelected
        });
    }

    render() {
        return (
            <ReactMultiSelectCheckboxes
                name="crisp_r1_merchant_name"
                isMulti
                value={this.state.merchantNameValue}
                styles={reactSelectStyles}
                className="report-listbox"
                isClearable={false}
                onChange={this.changeCrispR1MerchantName.bind(this)}
                options={this.state.merchantNameList}
                placeholderButtonLabel="Select [Merchant Name]"
                isLoading={this.state.isMerchantNameLoading}
            />
        );
    }
}

export default CrispR1MerchantNameFilter;
